import { ExpressionType } from '../ExpressionType';
export default function createConstant(value, type) {
    return {
        nodeType: ExpressionType.Constant,
        value,
        type,
    };
}
